module.exports = __webpack_public_path__ + "static/media/install-widget-video.91aebb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/install-widget-video.png
// module id = GeoU
// module chunks = 89